// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"24c1d605","431":"c79e9585","489":"b4a6ebbd","507":"42427a5d","608":"e0aed8c7","787":"e4654a24","880":"e440127c"}[chunkId] + ".chunk.js";
};